module.exports = __webpack_public_path__ + "static/media/transport with footer.3b032ac8.jpg";